/* eslint-disable */
const hash = {
  "en-US": "9312b813",
  "de-DE": "e1390b54",
  "es-ES": "52895f6c",
  "fr-FR": "a132666c",
  "id-ID": "c6089c9c",
  "it-IT": "fffb8053",
  "jp-JP": "5b8695b6",
  "ko-KO": "5ae7501b",
  "nl-NL": "1e6b3b67",
  "pl-PL": "cf93e620",
  "pt-PT": "29582958",
  "ru-RU": "cdf99889",
  "sv-SE": "b50b1a22",
  "tr-TR": "05ec4234",
  "vi-VN": "0552266b",
  "zh-CN": "0b6e5516",
  "zh-TW": "ba7b805f",
  "avatars": "0a04113d",
  "control": "1178ff0b",
  "custom-ai_companion": "3a175fd0",
  "plan-details": "b87cf1f7",
  "gov-EN": "0d3ff929",
  "en-GB": "8831d2e0"
}
export default hash
